import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap, TimelineLite} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritStatics} from "../../TrueGritStatics";
import {TrueGritModel} from "../../TrueGritModel";
import {TrueGritScatterSymbol} from "../../reels/TrueGritScatterSymbol";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TrueGritFreeSpinBetPresentation implements FlowStatePresentation {

    public start(flowStateController:FlowStateController) {
        TrueGrit.anticipationView.resetSoundFlags();

        //Fades out win numbers from previous win if any
        TrueGrit.totalWinView.abort();

        // #295
        TrueGritModel.previousFSLeft = TrueGrit.model.freespinsLeft;

        // #340
        TrueGrit.trueGritScatterSymbols.getAllUsedScatters().forEach((sym: TrueGritScatterSymbol) => sym.landedInThisOutcomeForFS = false);

        // #382 -> delay
        const delay: number = 0.15,
            tl:TimelineLite = new TimelineLite({delay: delay, onComplete : () => flowStateController.finish()}),
            mainReelDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.mainReelAllOutStopDelayFastSpin : TrueGritStatics.mainReelAllOutStopDelay,
            topReelDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.topReelAllOutStopDelayFastSpin : TrueGritStatics.topReelAllOutStopDelay,
            bottomReelDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.bottomReelAllOutStopDelayFastSpin : TrueGritStatics.bottomReelAllOutStopDelay;

        tl.add(()=> {TrueGrit.waysView.updateNumberOfWays(TrueGritModel.defaultNumberOfWaysForScatters[3])}, delay);

        tl.add(TrueGrit.allReelsView.topReelModel.start(), topReelDelay + delay);
        tl.add(TrueGrit.allReelsView.bottomReelModel.start(), bottomReelDelay + delay);
        tl.add(TrueGrit.allReelsView.mainReelModels[0].start(), delay);
        tl.add(TrueGrit.allReelsView.mainReelModels[1].start(), mainReelDelay + delay);
        tl.add(TrueGrit.allReelsView.mainReelModels[2].start(), (mainReelDelay * 2) + delay);
        tl.add(TrueGrit.allReelsView.mainReelModels[3].start(), (mainReelDelay * 3) + delay);
        tl.add(TrueGrit.allReelsView.mainReelModels[4].start(), (mainReelDelay * 4) + delay);
        tl.add(TrueGrit.allReelsView.mainReelModels[5].start(), (mainReelDelay * 5) + delay);

        if(tl.duration() == 0) {
            tl.add(gsap.to(this, {duration : 0.001}));
        }
    }
}